import React, { useState, useEffect } from 'react';
import { AdminLogin } from '../components/AdminLogin';
import { AdminDashboard } from '../components/AdminDashboard';

export default function Admin() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [adminToken, setAdminToken] = useState(() => {
    return localStorage.getItem('admin_token') || '';
  });

  // Admin handlers
  const handleAdminLogin = (token: string) => {
    setAdminToken(token);
    setIsAdminAuthenticated(true);
  };

  const handleAdminLogout = () => {
    localStorage.removeItem('admin_token');
    setAdminToken('');
    setIsAdminAuthenticated(false);
    window.location.href = '/';
  };

  // Validate admin token on mount
  useEffect(() => {
    const validateToken = async () => {
      if (adminToken) {
        try {
          const { verifyToken } = await import('../services/api');
          const isValid = await verifyToken(adminToken);
          
          if (isValid) {
            setIsAdminAuthenticated(true);
          } else {
            // Token is invalid or expired, clear it
            console.log('❌ Token invalid or expired, clearing...');
            handleAdminLogout();
          }
        } catch (error) {
          console.error('Token validation error:', error);
          handleAdminLogout();
        }
      }
    };

    validateToken();
  }, []); // Only run on mount

  // Render admin panel
  if (!isAdminAuthenticated) {
    return <AdminLogin onLogin={handleAdminLogin} />;
  }
  
  return <AdminDashboard token={adminToken} onLogout={handleAdminLogout} />;
}
